<template>
	<AppLayout
		:title="trans('admin.periods.events.edit.title')"
		:return-url="route('events.periods.index')"
		:return-label="trans('admin.periods.events.title')"
	>
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="update">
				<i class="fa-solid fa-save mr-2"/>
				{{ trans('general.save') }}
			</PrimaryButton>
		</template>
		<div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
			<LabeledObject required>
				<template #label>{{ trans('admin.periods.events.edition') }}</template>
				<input v-model="period.edition" type="text" maxlength="255">
			</LabeledObject>
			<LabeledObject required>
				<template #label>{{ trans('admin.periods.events.year') }}</template>
				<input v-model="period.year" type="number">
			</LabeledObject>
			<LabeledObject required>
				<template #label>{{ trans('admin.periods.events.begins_on') }}</template>
				<IconDateInput v-model="period.begins_on" icon-class="fa-solid fa-hourglass-start" :min="min" full/>
			</LabeledObject>
			<LabeledObject required>
				<template #label>{{ trans('admin.periods.events.ends_on') }}</template>
				<IconDateInput v-model="period.ends_on" icon-class="fa-solid fa-hourglass-end" :min="period.begins_on" full/>
			</LabeledObject>
			<LabeledObject required>
				<template #label>{{ trans('admin.periods.events.semester') }}</template>
				<select v-model="period.semester">
					<option v-for="semester in Semester" :value="semester">{{ trans(`events.semester.${semester}`) }}</option>
				</select>
			</LabeledObject>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {Semester} from '@/Types/Enums/Semester'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import IconDateInput from '@/Components/UI/Inputs/IconDateInput.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {type EventPeriod} from '@/Types/Periods/Events/EventPeriod'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'

const props = defineProps<{
	period:EventPeriod,
}>()

const min:Ref<string> = ref(dayjs().format('YYYY-MM-DD'))
const working:Ref<boolean> = ref(false)
const period:Ref<EventPeriod> = ref(props.period)
const selectedPeriod:Ref<EventPeriod | null> = ref(null)

function update():void{
	if(!working.value && selectedPeriod.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('events.periods.update', period.value.id), period.value).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>